import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import 'leaflet/dist/leaflet.css';
import './Contact.scss';
import { isValidEmail, isValidPhone, isValidString } from '../../utils/validation';
import DOMPurify from 'dompurify';

import logoPatte from '../../assets/img/logo-patte-removebg-preview.png';
import Tel from '../../assets/img/contact-tel.png';
import Mail from '../../assets/img/contact-mail.png';

import logoHomeContact from '../../assets/img/logo-home-contact.png';
import logoTelContact from '../../assets/img/logo-tel-contact.png';
import logoCourrierContact from '../../assets/img/logo-courrier-contact.png';

function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        tel: '',
        email: '',
        message: '',
    });
    const [formErrors, setFormErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState(''); // État pour le message de succès
    const [errorMessage, setErrorMessage] = useState(''); // État pour le message d'erreur

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({ ...prevState, [name]: value }));
        setFormErrors(prevErrors => ({ ...prevErrors, [name]: '' })); // Effacer l'erreur spécifique lors de la modification
    };

    const validateFormData = () => {
        let errors = {};

        if (!isValidString(formData.name)) {
            errors.name = 'Le nom est requis.';
        }
        if (!isValidEmail(formData.email)) {
            errors.email = 'L\'email n\'est pas valide.';
        }
        if (!isValidPhone(formData.tel)) {
            errors.tel = 'Le numéro de téléphone n\'est pas valide.';
        }
        if (!isValidString(formData.message)) {
            errors.message = 'Le message ne peut pas être vide.';
        }

        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        const errors = validateFormData();
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }
    
        let sanitizedFormData = {
            name: DOMPurify.sanitize(formData.name),
            email: DOMPurify.sanitize(formData.email),
            tel: DOMPurify.sanitize(formData.tel),
            message: DOMPurify.sanitize(formData.message),
        };
        
        try {
            // URL de l'API avec fallback
            const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
            const fullApiUrl = `${apiUrl}/api/send-email`;
            
            console.log('URL de l\'API:', fullApiUrl);
            console.log('Données envoyées:', sanitizedFormData);
            
            const response = await fetch(fullApiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(sanitizedFormData),
            });
    
            console.log('Status de la réponse:', response.status);
            console.log('Headers de la réponse:', response.headers);
            
            // Vérifier le type de contenu de la réponse
            const contentType = response.headers.get('content-type');
            console.log('Content-Type:', contentType);
            
            if (!contentType || !contentType.includes('application/json')) {
                // Si la réponse n'est pas du JSON, c'est probablement une erreur HTML
                const errorText = await response.text();
                console.error('Réponse non-JSON reçue:', errorText);
                throw new Error('Erreur de serveur - réponse non-JSON reçue');
            }
    
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Erreur lors de l\'envoi du message');
            }
    
            const result = await response.json();
            console.log('Succès:', result.message);
    
            setFormData({
                name: '',
                tel: '',
                email: '',
                message: '',
            });
            setSuccessMessage('Votre message a bien été envoyé.');
            setErrorMessage('');
            setTimeout(() => {
                setSuccessMessage('');
            }, 5000);
    
        } catch (error) {
            console.error('Erreur détaillée:', error);
            setErrorMessage(error.message || 'Erreur lors de l\'envoi du message');
            setSuccessMessage('');
        }
    };

    let DefaultIcon = L.icon({
        iconUrl: icon,
        shadowUrl: iconShadow,
        iconSize: [25, 41],
        iconAnchor: [12, 41]
    });

    L.Marker.prototype.options.icon = DefaultIcon;

    const position = [50.661444462572405, 3.229624875660113];

    return (
        <main className="contact-container">
            <div className="contact-background">
                <div className="contact-background__container-title">
                    <p className="contact-background__title">La Truffe à 4 Pattes</p>
                    <img className="contact-background__logo" src={logoPatte} alt="Logo" />
                </div>
            </div>
            <section className="contact-content">
                <h1 className='contact-content__main-title'>Contact</h1>
                <div className="contact-content__container">
                    <div className="contact-content__block">
                        <img className="contact-content__info-img" src={Tel} alt="Logo de téléphone" />
                        <div className="contact-content__info">
                            <h2 className="contact-content__title">Coordonnées</h2>
                            <div className="contact-content__container-text">
                                <p className="contact-content__text"> <img className="contact-content__logo" src={logoHomeContact} alt="Logo maison" />59390 Toufflers</p>
                                <p className="contact-content__text"> <img className="contact-content__logo" src={logoTelContact} alt="Logo téléphone" />07 83 38 12 93</p>
                                <p className="contact-content__text"> <img className="contact-content__logo" src={logoCourrierContact} alt="Logo courrier" />latruffea4pattes@gmail.com</p>
                            </div>
                            <div className="contact-map">
                                <MapContainer center={position} zoom={13} scrollWheelZoom={false} style={{ height: '400px', width: '100%' }}>
                                    <TileLayer
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                    />
                                    <Marker position={position}>
                                        <Popup>
                                            Un message ou une description ici.
                                        </Popup>
                                    </Marker>
                                </MapContainer>
                            </div>
                        </div>
                    </div>
                    <div className="liner-contact"></div>
                    <div className="contact-content__block">
                        <img className="contact-content__form-img" src={Mail} alt="Logo de mail" />
                        <div className="contact-content__form">
                            <h2 className="contact-content__title">Besoin d'un renseignement ? Contactez-nous</h2>
                            <form className='contact-form' onSubmit={handleSubmit}>

                                <label htmlFor="name">Nom:</label>
                                {formErrors.name && <p className="error">{formErrors.name}</p>}
                                <input type="text" id='name' name="name" value={formData.name} onChange={handleChange} />

                                <label htmlFor="tel">Téléphone:</label>
                                {formErrors.tel && <p className="error">{formErrors.tel}</p>}
                                <input type="tel" id='tel' name="tel" value={formData.tel} onChange={handleChange} />  

                                <label htmlFor="email">Email:</label>
                                {formErrors.email && <p className="error">{formErrors.email}</p>}
                                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} />

                                <label htmlFor="message">Message:</label>
                                {formErrors.message && <p className="error">{formErrors.message}</p>}
                                <textarea name="message" id='message' value={formData.message} onChange={handleChange}></textarea>
                                {successMessage && <p className="success-message">{successMessage}</p>} {/* Afficher le message de succès */}
                                {errorMessage && <p className="error-message">{errorMessage}</p>} {/* Afficher le message d'erreur */}
                                <button type="submit">Envoyer</button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default Contact;
